/** Appliers barrel + the per-action dispatcher. */
import type { AugmentedWarAction } from "../types/action";
import type { AugmentedWarState } from "../types/game-state";
import {
  applyAttack,
  applyDeclareAttack,
  applyResolveAttack,
} from "./attack.applier";
import { applyDeploy } from "./deploy.applier";
import { applyEndTurn } from "./end-turn.applier";
import { applyMove } from "./move.applier";

export {
  applyAttack,
  applyDeclareAttack,
  applyResolveAttack,
} from "./attack.applier";
export { applyDeploy } from "./deploy.applier";
export { applyEndTurn } from "./end-turn.applier";
export { applyMove } from "./move.applier";

export function applyAction(
  state: AugmentedWarState,
  action: AugmentedWarAction,
): AugmentedWarState {
  switch (action.type) {
    case "Move":
      return applyMove(state, action);
    case "Attack":
      return applyAttack(state, action);
    case "DeclareAttack":
      return applyDeclareAttack(state, action);
    case "ResolveAttack":
      return applyResolveAttack(state, action);
    case "Deploy":
      return applyDeploy(state, action);
    case "EndTurn":
      return applyEndTurn(state, action);
  }
}
